// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jZkItogcV92l6O4Tgxps{color:rgba(255,255,255,.7)}`, "",{"version":3,"sources":["webpack://./src/widgets/MediaLibrary/ui/MediaLibraryModal/MediaLibraryInfoTooltips/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,0BAAA","sourcesContent":[".description {\n  color: rgba(255, 255, 255, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `jZkItogcV92l6O4Tgxps`
};
export default ___CSS_LOADER_EXPORT___;
